// frontend/klaes-app/src/components/FilmFavs/components/SearchModal.jsx
import { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { Chip } from './Chip';
import { TagPicker } from './TagPicker';
import styles from '../FilmFavs.module.css';

const defaultTypeOptions = [
  { value: 'both', label: 'Beide' },
  { value: 'film', label: 'Filme' },
  { value: 'series', label: 'Serien' }
];

export const SearchModal = ({
  onSearch,
  onClose,
  allTags,
  onCreateTag,
  typeOptions = defaultTypeOptions,
  tagCategories,
  searchPlaceholder = 'Name oder Beschreibung...'
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const [typeFilter, setTypeFilter] = useState('both');
  const [showTagPicker, setShowTagPicker] = useState(false);
  const [searchMode, setSearchMode] = useState('or'); // 'or' oder 'and'

  const toggleTag = (tag) => {
    if (selectedTags.find(t => t.name === tag.name && t.category === tag.category)) {
      setSelectedTags(selectedTags.filter(t => t.name !== tag.name || t.category !== tag.category));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleSearch = () => {
    onSearch({
      term: searchTerm,
      tags: selectedTags,
      type: typeFilter,
      matchMode: searchMode  // 'or' oder 'and'
    });
  };

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose}>
        <div className={`${styles.modal} ${styles.searchModal}`} onClick={(e) => e.stopPropagation()}>
          <h3>Erweiterte Suche</h3>

          {/* Suchmodus Toggle */}
          <div className={styles.formGroup}>
            <label>Suchmodus</label>
            <div className={styles.searchModeButtons}>
              <button 
                type="button"
                className={`${styles.searchModeBtn} ${searchMode === 'or' ? styles.active : ''}`}
                onClick={() => setSearchMode('or')}
                title="Mindestens einer der Tags muss zutreffen"
              >
                🎲 OR (mindestens einer)
              </button>
              <button 
                type="button"
                className={`${styles.searchModeBtn} ${searchMode === 'and' ? styles.active : ''}`}
                onClick={() => setSearchMode('and')}
                title="Alle Tags müssen zutreffen"
              >
                🔒 AND (alle müssen)
              </button>
            </div>
            <small className={styles.searchModeHint}>
              {searchMode === 'or' 
                ? 'Zeigt Einträge, die mindestens einen der gewählten Tags haben' 
                : 'Zeigt NUR Einträge, die ALLE gewählten Tags haben'}
            </small>
          </div>

          <div className={styles.formGroup}>
            <label>Suchbegriff</label>
            <input 
              type="text" 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={searchPlaceholder}
              className={styles.input}
            />
          </div>

          <div className={styles.formGroup}>
            <label>Typ</label>
            <div className={styles.typeButtons}>
              {typeOptions.map(option => (
                <button
                  key={option.value}
                  type="button"
                  className={`${styles.typeBtn} ${typeFilter === option.value ? styles.active : ''}`}
                  onClick={() => setTypeFilter(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label>Tags</label>
            <button type="button" onClick={() => setShowTagPicker(true)} className={styles.openTagPickerBtn}>
              🏷️ Tags auswählen ({selectedTags.length})
            </button>
            <div className={styles.selectedTags}>
              {selectedTags.map((tag, i) => (
                <Chip key={i} label={tag.name} category={tag.category} onRemove={() => toggleTag(tag)} />
              ))}
            </div>
          </div>

          <div className={styles.modalButtons}>
            <button onClick={handleSearch} className={styles.searchBtn}><FiSearch /> Suchen</button>
            <button onClick={onClose} className={styles.cancelBtn}>Abbrechen</button>
          </div>
        </div>
      </div>

      {showTagPicker && (
        <TagPicker 
          onSelectTag={toggleTag}
          onClose={() => setShowTagPicker(false)}
          existingTags={allTags}
          onCreateTag={onCreateTag}
          selectedTags={selectedTags}
          tagCategories={tagCategories}
        />
      )}
    </>
  );
};